import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import CommonFooter from '../../common_components/CommonFooter';
import AccessRestrictedContent from '../../common_components/AccessRestrictedContent';
const BG = '#F8F9FC';
const SURFACE = '#FFFFFF';
const BORDER = '#E9EAEB';
export default function AccessRestricted({ isDashboard = false }) {
    return (_jsxs(Box, { sx: isDashboard ? {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
        } : {
            minHeight: '100vh',
            backgroundColor: BG,
            fontFamily: 'Inter, system-ui, sans-serif',
            display: 'flex',
            flexDirection: 'column',
            backgroundImage: `radial-gradient(circle, ${BORDER} 1px, transparent 1px)`,
            backgroundSize: '24px 24px',
        }, children: [!isDashboard && (_jsx(Box, { sx: {
                    height: 60,
                    backgroundColor: SURFACE,
                    borderBottom: `1px solid ${BORDER}`,
                    display: 'flex',
                    alignItems: 'center',
                    px: { xs: 3, sm: '40px' },
                    flexShrink: 0,
                    boxShadow: '0px 1px 2px rgba(10,13,18,0.04)',
                }, children: _jsx(Box, { component: "img", src: "/assets/loginImage/logo-final.svg", alt: "Group8A", sx: { height: 28 } }) })), _jsx(Box, { sx: {
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: 2,
                    py: 5,
                }, children: _jsx(AccessRestrictedContent, {}) }), !isDashboard && _jsx(CommonFooter, {})] }));
}
